import { CloudAccountType } from '@internal/backstage-plugin-catalog-devops-common';
import { ModernSelect } from '@internal/backstage-plugin-devops-react';

interface AccountTypeInputProps {
  accountType: string;
  setAccountType: (accountType: string) => void;
  isInvalid?: boolean;
  disabled?: boolean;
}

export const AccountTypeInput = (props: AccountTypeInputProps) => {
  const { accountType, setAccountType, isInvalid, disabled } = props;

  return (
    <ModernSelect
      label="Type"
      options={Object.values(CloudAccountType).map(type => ({
        label: type,
        value: type,
      }))}
      value={accountType}
      onChange={value => setAccountType(value as CloudAccountType)}
      isInvalid={isInvalid}
      isDisabled={disabled}
      isRequired
    />
  );
};
